/**
 * This enum is used to define the effective mode of the thermostat used by thermostat component.
 * 
 * ATTENTION!!!
 * 
 * The order of the elements in this enum IS SIGNIFICATIVE, since it is used in the logic of some important method contained in these components:
 * * Thermostast-expanded-section.component (.ts AND .html) 
 * * Widget-thermostat.component (.ts)
 * 
 * If there is need to change this, it is advisible to add new items on the bottom of the enum and, if changes are made to pre-existing items, to checke
 * the above component to be sure the modofication will not cause errors.
 */
export enum ThermostatHVACMode {
    UNKNOWN = 0,
    COMFORT = 1,
    STANDBY = 2,
    ECO = 3,
    PROTECTION = 4,
}